declare namespace $ {

	type $mol_check__title_bog_music_qrscan_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_bog_music_qrscan_2 = $mol_type_enforce<
		ReturnType< $bog_music_qrscan['scanning'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_video_camera__facing_bog_music_qrscan_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_video_camera['facing'] >
	>
	type $mol_video_camera__muted_bog_music_qrscan_4 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_camera['muted'] >
	>
	export class $bog_music_qrscan extends $mol_view {
		Toggle( ): $mol_check
		Camera( ): $mol_video_camera
		scanning( next?: boolean ): boolean
		prefix( ): string
		found( next?: string ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=qrscan.view.tree.d.ts.map